import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";

export function useQuote(
  items,
  code = "",
  email = "",
  shippingAddress = null,
  shippingServiceKey = "",
  enabled = true,
) {
  const [quote, setQuote] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const key = JSON.stringify([
    items.map((i) => [i.product_id, i.color, i.quantity]),
    code,
    email,
    shippingAddress,
    shippingServiceKey,
  ]);

  useEffect(() => {
    if (!items.length || !enabled) {
      setQuote(null);
      setError("");
      setLoading(false);
      return undefined;
    }
    let active = true;
    setError("");
    setLoading(true);
    const t = setTimeout(
      () => {
        api
          .post("/cart/quote", {
            items: items.map((i) => ({
              product_id: i.product_id,
              color: i.color,
              quantity: i.quantity,
            })),
            code,
            email: email.includes("@") ? email : "",
            shipping_address: shippingAddress,
            shipping_service_key: shippingServiceKey,
          })
          .then((r) => {
            if (active) {
              setQuote(r.data);
              setError("");
            }
          })
          .catch((e) => {
            if (active) {
              setQuote(null);
              setError(errMsg(e));
            }
          })
          .finally(() => {
            if (active) setLoading(false);
          });
      },
      shippingAddress ? 650 : 250,
    );
    return () => {
      active = false;
      clearTimeout(t);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, enabled]);

  return { quote, error, loading };
}
